var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4402 16.596V5.0664C19.4402 4.28755 18.8265 3.65559 18.0686 3.65559H16.2093V17.0142C16.2093 18.2166 16.5168 18.4584 17.0835 18.6641C17.5019 18.8158 18.0978 18.7666 18.0978 18.7666C18.8902 18.3833 19.4402 17.5566 19.4402 16.596Z",
    fill: "#189A55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3405 17.0142V3.65491V2.4108C17.3405 1.63127 16.7267 1 15.9688 1H1.3717C0.613776 1 0 1.63127 0 2.4108V17.5867C0 18.3655 0.613776 18.9975 1.3717 18.9975H1.42218H16.9738C17.6381 19.0296 17.9955 18.8178 18.2605 18.6805C18.2605 18.6805 17.3405 18.8923 17.3405 17.0142Z",
    fill: "#36C281"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90573 6.58788C9.89405 6.58788 10.6952 5.76384 10.6952 4.74734C10.6952 3.73084 9.89405 2.90681 8.90573 2.90681C7.9174 2.90681 7.11621 3.73084 7.11621 4.74734C7.11621 5.76384 7.9174 6.58788 8.90573 6.58788Z",
    fill: "white",
    fillOpacity: 0.47
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90573 15.753C9.89405 15.753 10.6952 14.9289 10.6952 13.9124C10.6952 12.8959 9.89405 12.0719 8.90573 12.0719C7.9174 12.0719 7.11621 12.8959 7.11621 13.9124C7.11621 14.9289 7.9174 15.753 8.90573 15.753Z",
    fill: "white",
    fillOpacity: 0.47
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6406 15.753C14.6289 15.753 15.4301 14.9289 15.4301 13.9124C15.4301 12.8959 14.6289 12.0719 13.6406 12.0719C12.6523 12.0719 11.8511 12.8959 11.8511 13.9124C11.8511 14.9289 12.6523 15.753 13.6406 15.753Z",
    fill: "white",
    fillOpacity: 0.47
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17153 15.753C5.15986 15.753 5.96105 14.9289 5.96105 13.9124C5.96105 12.8959 5.15986 12.0719 4.17153 12.0719C3.18321 12.0719 2.38202 12.8959 2.38202 13.9124C2.38202 14.9289 3.18321 15.753 4.17153 15.753Z",
    fill: "white",
    fillOpacity: 0.47
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64007 7.48007H9.36008V9.06105H14.0292V11.539H13.252V9.86039H4.56014V11.3258H3.78296V9.06105H8.64007V7.48007Z",
    fill: "white",
    fillOpacity: 0.47
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.2e7da8ad3494e4403766e09345dbdead.svg";
export { ForwardRef as ReactComponent };